import { Col, Row } from "react-bootstrap";

import ContactData from "../../data/contact.json"
import React from "react";

export const Cookie = () => {

	const rowStyle = {
		color: 'white',
		backgroundColor: 'black',
		padding: '5vh 10vw  20vh  10vw',
	};

	return (
		<Row style={rowStyle}>
			<Col md={12} className="">
			<h2 className="text-center"><strong >Cookie Policy</strong></h2><br /><br />
				<p>
					In accordance with the General Data Protection Regulation (GDPR) of the European Union and the Italian national laws on personal data protection, this Cookie Policy concerns the use of cookies on our website, accessible at the address {ContactData.siteAdress}.
				</p>
				<p>
					<strong>Cookie</strong><br />
					A cookie is a small text file sent by some web services and stored on your device (computer, smartphone, tablet) while you browse the Internet. However, we want to clarify that our website does not use cookies. We do not collect personal information through cookies, nor do we use similar tracking technologies.
				</p>
				<p>
					<strong>Processing Purposes</strong><br />
					Since we do not use cookies, we do not collect personal data through this technology. We do not collect or share any personal information about users of our site through cookies.
				</p>
				<p>
					<strong>Cookie Management</strong><br />
					Since we do not use cookies, there is no need to manage them or provide consent options for their use on our site.
				</p>
				<p>
					<strong>Data Subject Rights</strong><br />
					According to current laws, you have the right to request information about the management of cookies by our site. To exercise these rights or to ask questions about our cookie management policy, you can contact us using the contact details provided below.
				</p>
				<p>
					<strong>Contact</strong><br />
					{ContactData.name}<br />
					<span dangerouslySetInnerHTML={{ __html: ContactData.adressMain }} /><br />
					Vat: {ContactData.vat}<br />
					Email: <a href={`mailto:${ContactData.emailAddress}`} style={{color:'white'}}>{ContactData.emailAddress}</a>
				</p>
				<p>
					<strong>Updates</strong><br />
					This Cookie Management Policy is subject to changes and updates. We recommend checking it periodically to stay informed about our practices.
					<br />
					Last update: October 30, 2023
				</p>

			</Col>
		</Row>
	);
};
